import React from 'react';
import HeaderBar from '../components/HeaderBar';
import { Link } from 'react-router-dom';

export default function LandingPage() {
  return (
    <main className="home-page">
      {/* Modern Material UI HeaderBar */}
      <HeaderBar />
      {/* Header */}
      <header className="header">
        <div className="info">
          <h1>Experience the Best in Financial Solutions</h1>
          <p>Secure your finances and maximize your savings potentials.</p>
          <button className="blue"><Link to="/register">Open your account</Link></button>
        </div>
        <div className="img">
          <img src="/static/media/home-header.ea2b311d3df9c798bdd0.webp" alt="header" />
        </div>
      </header>
      {/* Stats Section */}
      <section className="stats">
        <div className="stat">
          <h2>50+ million</h2><span>accounts</span>
        </div>
        <div className="stat">
          <h2>2000+</h2><span>US public companies to invest</span>
        </div>
        <div className="stat">
          <h2>250+ million</h2><span>transactions worldwide</span>
        </div>
        <img src="/static/media/globe.bf6a72b92e46a9c270be21f94fb07d89.svg" alt="globe" />
      </section>
      {/* Banking Offers */}
      <section className="banking-offers">
        <div className="container">
          <div className="offer ">
            <div className="img"><img src="/static/media/home-offers-savings.7a43efd6eefc9d01f2f9bbf9b444cdfe.svg" alt="Savings" /></div>
            <div className="info">
              <h3>Savings</h3>
              <p>We offer a range of savings accounts to help you achieve your financial goals. Whether you're saving for a rainy day or planning for a big purchase, we have the right account for you. With competitive interest rates and convenient online access, saving has never been easier. Open an account today and start watching your money grow.</p>
              <button className="transparent"><Link to="/register">Get started</Link></button>
            </div>
          </div>
          <div className="offer reverse">
            <div className="img"><img src="/static/media/home-offers-investments.54dbbde035a43c660f4b8f69af55d049.svg" alt="Investments" /></div>
            <div className="info">
              <h3>Investments</h3>
              <p>We believe that investing is key to building long-term wealth. That's why we offer a range of investment options to help you achieve your financial goals. From retirement accounts to stocks and bonds, our financial experts can help you make informed investment decisions and grow your wealth over time. Start investing in your future today with Safenet Banking.</p>
              <button className="transparent"><Link to="/register">Get started</Link></button>
            </div>
          </div>
          <div className="offer ">
            <div className="img"><img src="/static/media/home-offers-credit-card.d7c6002afa7fcfa498f94459fadd451e.svg" alt="Credit card" /></div>
            <div className="info">
              <h3>Credit card</h3>
              <p>With our credit card, you have the power to make purchases whenever and wherever you need to. Our credit cards offer a range of features and benefits to help you manage your spending and build your credit. From cash back rewards to travel points, our credit cards have the rewards you want and the flexibility you need.</p>
              <button className="transparent"><Link to="/register">Get started</Link></button>
            </div>
          </div>
          <div className="offer reverse">
            <div className="img"><img src="/static/media/home-offers-loans.3173b928a4f299463cad8ce434ad4efb.svg" alt="Loans" /></div>
            <div className="info">
              <h3>Loans</h3>
              <p>Whether you're buying a home, starting a business, or just need some extra cash, we have the loan options you need to get the financing you need. From personal loans to mortgages, our loan experts can help you find the right option for your financial needs. With competitive rates and flexible repayment options, our loans make it easy to achieve your goals and stay on track financially.</p>
              <button className="transparent"><Link to="/register">Get started</Link></button>
            </div>
          </div>
        </div>
      </section>
      {/* The Right Account Section */}
      <section className="the-right-account">
        <h2 className="title">The right account to serve the right purpose</h2>
        <p className="sub-title">With a variety of account options to help you manage your money and reach your financial goals. Whether you're looking for a basic checking account or a high-yield savings option, we have the right account for you.</p>
        <div className="cards">
          <div className="cont">
            <div className="card">
              <div className="img"><img src="/static/media/checking-account.866414212ef45722a4b990a5e4d8b41b.svg" alt="Checking Account" /></div>
              <h3>Checking Account</h3>
              <p>A checking account offers easy access to your money for your daily transactional needs and helps keep your cash secure.</p>
              <button className="transparent"><Link to="/register">Open Account</Link></button>
            </div>
            <div className="card">
              <div className="img"><img src="/static/media/savings-account.a057c9716982d9197ab2874a98efe25c.svg" alt="Savings Account" /></div>
              <h3>Savings Account</h3>
              <p>A savings account is a bank account at a retail bank. Common features include a limited number of withdrawals, a lack of cheque and linked debit card facilities, limited transfer options and the inability to be overdrawn. </p>
              <button className="transparent"><Link to="/register">Open Account</Link></button>
            </div>
            <div className="card">
              <div className="img"><img src="/static/media/business-account.f5981fa1b02335cb1a1cbf7b78e1f0bd.svg" alt="Business Account" /></div>
              <h3>Business Account</h3>
              <p>A business bank account is a bank account that's used only for business transactions rather than personal finances. It can be opened in the name of the business, allowing payments to be made and received using the business's name.</p>
              <button className="transparent"><Link to="/register">Open Account</Link></button>
            </div>
            <div className="card">
              <div className="img"><img src="/static/media/iras.965ada2fb0a91244a16eb192efe22692.svg" alt="IRAs" /></div>
              <h3>IRAs</h3>
              <p>A business bank account is a bank account that's used only for business transactions rather than personal finances. It can be opened in the name of the business, allowing payments to be made and received using the business's name.</p>
              <button className="transparent"><Link to="/register">Open Account</Link></button>
            </div>
          </div>
        </div>
      </section>
      {/* Security Section */}
      <section className="top-priority">
        <h2 className="title">Your Security Is Our Top Priority</h2>
        <p className="sub-title">We understand that keeping your financial information safe and secure is of the utmost importance. That's why we have implemented the latest security measures to protect your accounts and prevent fraud.</p>
        <div className="cards">
          <div className="card">
            <div className="img"><img src="/static/media/encryption.6e623085655ac28fd0d2704abd6c62c4.svg" alt="encryption" /></div>
            <h3>Encryption</h3>
            <p>We use encryption to protect your data as it travels between your computer or mobile device and our servers. This ensures that your information is kept private and secure.</p>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/fraud-monitoring.db0d3a33a554b92a3206e5d774b458a2.svg" alt="Fraud Monitoring" /></div>
            <h3>Fraud Monitoring</h3>
            <p>We monitor your accounts for suspicious activity around the clock, using advanced fraud detection tools and techniques to keep your accounts secure.</p>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/zero-liability-protection.a5bf4c272b44243862b6190d03ffbf37.svg" alt="Zero Liability Protection" /></div>
            <h3>Zero Liability Protection</h3>
            <p>In the unlikely event that your account is compromised, we offer zero liability protection for fraudulent transactions made with your account.</p>
          </div>
        </div>
      </section>
      {/* Customer Testimonials */}
      <section className="customer-testimonails">
        <h2 className="title">Customer Testimonials</h2>
        <p className="sub-title">Hear what our satisfied customers have to say</p>
        <div className="cards">
          <div className="cont">
            <div className="card">
              <div className="customer">
                <div className="img"><img src="/static/media/testimonial-customer-1.0ae1a6546b910f72e6c5.webp" alt="customer" /></div>
                <h4><span>Abraham</span><span>Benjamin</span></h4>
              </div>
              <p>I've been using this bank's online platform for years now, and it's been a game-changer. I can easily access my account information, make transfers, and pay bills all from the comfort of my own home. The website is intuitive and user-friendly, and I highly recommend it to anyone looking for a reliable online banking experience.</p>
            </div>
            <div className="card">
              <div className="customer">
                <div className="img"><img src="/static/media/testimonial-customer-2.fadc6ecc44a0d4499df4.jpeg" alt="customer" /></div>
                <h4><span>Kelvin</span><span>David</span></h4>
              </div>
              <p>As a small business owner, I rely on this bank's website to manage my finances efficiently. The website allows me to easily view my account balances, track transactions, and schedule payments. The customer service team is also incredibly responsive and helpful, making the overall banking experience a breeze.</p>
            </div>
            <div className="card">
              <div className="customer">
                <div className="img"><img src="/static/media/testimonial-customer-3.68e6b8ecd3546aad9b13.jpeg" alt="customer" /></div>
                <h4><span>Sarah </span><span>Maclean</span></h4>
              </div>
              <p>I've been a loyal customer of this bank for years, and their website has only made my experience better. The website is constantly updated with new features and functionalities, making it easier than ever to manage my finances. Whether I need to transfer funds or deposit a check, I can do it all from the convenience of my own computer.</p>
            </div>
          </div>
        </div>
      </section>
      {/* Financial Freedom CTA */}
      <article className="financial-freedom">
        <div className="text">
          <h2>Take a Step Towards Financial Freedom</h2>
          <p>Ready to start achieving your financial goals? Open an account today and discover the benefits of banking with us all from the comfort of your home.</p>
          <button className="white"><Link to="/register">Open an account today</Link></button>
        </div>
        <div className="img"><img src="/static/media/financial-freedom.81826f816f2e9f3fe1c9.png" alt="financial freedom" /></div>
      </article>
      {/* Footer */}
      <footer className="footer">
        <div className="grid">
          <div className="item logo-info">
            <div className="logo">
              {/* <img src="/static/media/company-logo-alt.d373336d50678ed7656225afbffc4b81.svg" alt="company logo" /> */}
            </div>
            <p>At Safenet Banking, your financial security is our top priority. We are committed to providing you with a seamless and secure online banking experience.</p>
          </div>
          <div className="item list">
            <h3>Company</h3>
            <ul>
              <li><Link to="/about">About us</Link></li>
              <li><Link to="/terms-and-conditions">Terms & conditions</Link></li>
              <li><Link to="/privacy-policies">Privacy policies</Link></li>
            </ul>
          </div>
          <div className="item list">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/security">Security</Link></li>
            </ul>
          </div>
          <div className="item list">
            <h3>Customer Support</h3>
            <ul>
              <li><Link to="/contact">Get help</Link></li>
              <li><Link to="/frequently-asked-questions">FAQs</Link></li>
              <li><a href="mailto:info@safenetbanking.com">Email us</a></li>
            </ul>
          </div>
          <div className="item socials">
            <h3>Follow us</h3>
            <ul>
              <li><a href=""><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path></svg></a></li>
              <li><a href=""><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path></svg></a></li>
              <li><a href=""><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g><path fill="none" d="M0 0h24v24H0z"></path><path fillRule="nonzero" d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153 4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6.5-.25a1.25 1.25 0 0 0-2.5 0 1.25 1.25 0 0 0 2.5 0zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"></path></g></svg></a></li>
              <li><a href=""><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path></svg></a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>Copyright 2022 Safenet Banking. Licensed by the Central Bank of United States.</p>
        </div>
      </footer>
    </main>
  );
}
